import { Cushion, FlexContainer, Grid, Rectangle, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import FormGuidePlayer from './form-guide-player';

const FormGuidePlayerStats = ({ stats, overview, teamId }) => {
  const renderTeamStats = ({ teamName, teamStats, homeOrAway }) => (
    <FlexContainer
      flexDirection="column"
      alignItems="center"
      style={{ gap: '20px', padding: '20px 0' }}
      component="div"
    >
      <Typography size={16} weight="bold">
        {teamName}
      </Typography>
      <Grid columns="1fr" rowGap="5px" style={{ width: '100%', padding: '0 20px' }}>
        {teamStats.map((player) => (
          <FormGuidePlayer
            key={`${homeOrAway}-${player.id}`}
            player={player}
            teamId={homeOrAway === 'h' ? teamId : null}
          />
        ))}
      </Grid>
    </FlexContainer>
  );
  return (
    <>
      {stats.map((stat) => (
        <Rectangle
          fill="white"
          style={{ border: '1px solid #d9d9d9', overflow: 'hidden' }}
          responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
        >
          <Rectangle fill="#fafafa">
            <Cushion all="small">
              <Typography size={16} weight="bold" color="black" align="center" component="h3">
                {stat.name}
              </Typography>
            </Cushion>
          </Rectangle>
          <Grid
            columns="1fr"
            responsive={[
              { minWidth: 'fullHeader', props: { columns: '1fr 1fr', columnGap: '20px' } },
            ]}
          >
            {renderTeamStats({
              teamName: overview.home.name,
              teamStats: stat.home,
              homeOrAway: 'h',
            })}
            {renderTeamStats({
              teamName: overview.away.name,
              teamStats: stat.away,
              homeOrAway: 'a',
            })}
          </Grid>
        </Rectangle>
      ))}
    </>
  );
};

FormGuidePlayerStats.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      home: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          avatar: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
      away: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          avatar: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  overview: PropTypes.shape({
    ha: PropTypes.string,
    home: PropTypes.shape({
      name: PropTypes.string.isRequired,
      colours: PropTypes.shape({
        primary: PropTypes.string.isRequired,
        primary_contrast: PropTypes.string.isRequired,
      }),
    }),
    away: PropTypes.shape({
      name: PropTypes.string.isRequired,
      colours: PropTypes.shape({
        primary: PropTypes.string.isRequired,
        primary_contrast: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  teamId: PropTypes.number.isRequired,
};

export default FormGuidePlayerStats;
